var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRedirectGreen = function SvgIconRedirectGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#429D15",
    d: "M8 1.836a6.67 6.67 0 0 0-6.667 6.667A6.67 6.67 0 0 0 8 15.169a6.67 6.67 0 0 0 6.666-6.666A6.67 6.67 0 0 0 8 1.836m3.5 6.887c0 .273-.227.5-.5.5a.504.504 0 0 1-.5-.5V6.709l-5.147 5.147a.495.495 0 0 1-.707 0 .503.503 0 0 1 0-.707l5.147-5.146H7.78a.504.504 0 0 1-.5-.5c0-.274.226-.5.5-.5H11c.273 0 .5.226.5.5z"
  })));
};
export default SvgIconRedirectGreen;